import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { ContentTypeFilterClause,ExplorableItemDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ContentFiltersKeys } from '~src/spacesPlatform/models/ContentFilters';
import { Users } from '~src/userManagement/services/resources/Users';

import { getNoDefaultFilters } from './getDefaultFilters';

export const SearchUserDefinition: ExplorableItemDefinition = {
  itemType: 'searchuser',
  pluralName: Messages.users,
  singularName: Messages.user,
  emptyStateMessage: Messages.usersEmptyMessage,
  contentFilterKeys: [ContentFiltersKeys.search],
  defaultFilters: getNoDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['searchuser']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return Users.instance.all().withExtraParams({
      'getItemCounts': true
    });
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
